<template>
    <div>
        <form action>
            <input type="text" id="autocomplete" ref="autocomplete" :placeholder="placeholder" />
        </form>

        <transition>
        <div v-if="stores.length > 0">
            <div class="store-list">
                <div class="store" v-for="(store, index) in filteredStores" :key="index">
                    <input :id="`detail-${index}`" type="radio" v-model="checkedstore" :value="store" />
                    <label :for="`detail-${index}`">
                        <div class="store-list-heading">{{ store.title | titlecase }}</div>
                        <div class="store-list-desc">{{ `${store.address} ${store.suburb}` | titlecase }} {{ store.state }} {{ store.postcode }}</div>
                        <!-- <div class="store-list-desc"> {{ store.store_service_slugs }}</div> -->
                    </label>
                </div>
            </div>
        </div>
        <div v-if="(filteredStores.length == 0) && clickedSearch">
            <div class="store-list">
                <div class="store">                    
                    <label>                        
                        <div class="store-list-desc">{{ empty_result }}</div>
                    </label>
                </div>
            </div>
        </div>

        </transition>
    </div>
</template>

<script>
import axios from "axios";
import gmapsInit from "../utils/gmaps.js";

export default {
    name: "store-locator-wishlist",
    props: {
        latitude: {
            type: String
        },
        longitude: {
            type: String
        },
        formatted_address: {
            type: String
        },
        store_products: {
            type: String,
            default: "{}"
        },
        store_services: {
            type: String,
            default: "{}"
        },
        placeholder: {
            type: String,
            required: true,
            default: "Search by suburb or postcode"
        },
        search: {
            type: String,
            required: true,
            default: "Search"
        },
        refine: {
            type: String,
            required: true,
            default: "Refine"
        },
        distance: {
            type: String,
            required: true,
            default: "Distance"
        },
        location: {
            type: String,
            required: true,
            default: "Location"
        },
        stores_within: {
            type: String,
            required: true,
            default: "stores within"
        },
        refine_your_search: {
            type: String,
            required: true,
            default: "Refine your search"
        },
        no_phone_number: {
            type: String,
            required: true,
            default: "No Phone Number"
        },
        learn_more: {
            type: String,
            required: true,
            default: "Learn More"
        },
        stocks: {
            type: String,
            required: true,
            default: "Stocks"
        },
        services: {
            type: String,
            required: true,
            default: "Services"
        },
        filter_by_stock_type: {
            type: String,
            required: true,
            default: "Filter by Stock Type"
        },
        filter_by_services: {
            type: String,
            required: true,
            default: "Filter by Services"
        },
        empty_result: {
            type: String,
            default: "Result is empty"
        },
        fitting_types: {
            type: Array,
            required: true
        },
    },
    data() {
        return {
            baseUrl: "api/search/store/",
            radius: 1000,
            limit: 100,
            stores: [],
            checkedstore: null,
            serviceTypes: [],
            serviceFilters: [],
            stockTypes: [],
            stockFilters: [],
            lat: null,
            lng: null,
            postcode: null,
            showFilters: false,
            filterIcon: "../images/temp/filter.svg",
            closeIcon: "../images/temp/close-2.svg",
            clickedSearch : false
        };
    },
    async mounted() {
        // create google
        window.google = await gmapsInit();

        // set initial lat and lng to props
        this.lat = this.latitude;
        this.lng = this.longitude;

        if (this.formatted_address) {
            this.$refs.autocomplete.value = this.formatted_address;
        }

        if (this.lat && this.lng) {
            this.getData();
        }

        const autocomplete = new window.google.maps.places.Autocomplete(
            this.$refs.autocomplete,
            {
                componentRestrictions: {
                    country: window.culture.split("-")[1]
                },
                types: ["(regions)"]
            }
        );

        autocomplete.addListener("place_changed", () => {
            this.lat = null;
            this.lng = null;

            let place = autocomplete.getPlace();

            // get postcode
            this.postcode = this.extractPostcode(place.address_components);

            // set lat and long
            this.lat = place.geometry.location.lat();
            this.lng = place.geometry.location.lng();
            this.getData();
        });
    },
    watch: {
        checkedstore: function(val) {
            this.$emit("storeSelected", val);
        }
    },
    computed: {
        url() {
            return `${this.baseUrl}${this.lat}/${this.lng}/${this.radius}/${this.limit}/true`;
        },
        storeProducts() {
            return JSON.parse(this.store_products);
        },
        storeServices() {
            return JSON.parse(this.store_services);
        },
        filteredStores() {
            let stores = this.stores;

            // If no filters, return all stores
            if (this.fitting_types.length == 0 && this.stockFilters.length == 0) {
                return stores;
            }

            let filtered = [];

            stores.forEach(store => {


                // check service filters
                if (store.store_service_slugs.length) {            

                    store.store_service_slugs.forEach(slug => {
                        if (this.fitting_types.includes(slug)) {
                            filtered.push(store);
                        }
                    });
                }

                // check stock filters
                // if (store.store_stock_ids != null && this.stockFilters.length > 0) {
                //     let stockIds = store.store_stock_ids
                //         .split(",")
                //         .map(id => parseInt(id));

                //     this.stockFilters.forEach(stockId => {
                //         if (stockIds.includes(stockId)) {
                //             filtered.push(store);
                //         }
                //     });
                // }
            });

            return [...new Set(filtered)];
        }
    },
    methods: {
        async getData() {

            let response = await axios.get(this.url);

            this.stores = response.data.data.stores;
            this.serviceTypes = response.data.data.service_types;
            this.stockTypes = response.data.data.stock_types;

            if (this.filteredStores[0]) {
                this.checkedstore = this.filteredStores[0];
            }
            this.clickedSearch = true;
        },
        extractPostcode(address) {
            let postcode;
            address.forEach(part => {
                if (part.types[0] == "postal_code") {
                    postcode = part.long_name;
                }
            });

            return postcode;
        },
        getStockTypes(store) {
            let list = [];
            // check if there are ids
            if (store.store_stock_ids !== null) {
                let stockIds = store.store_stock_ids.split(",");

                // now match to the stock list to get name and icon
                stockIds.forEach(id => {
                    this.stockTypes.forEach(type => {
                        if (id == type.id) {
                            list.push(type);
                        }
                    });
                });
            }

            return list;
        },
        getServiceTypes(store) {
            let list = [];
            // check if there are ids
            if (store.store_service_ids !== null) {
                let serviceIds = store.store_service_ids.split(",");

                // now match to the service list to get name and icon
                serviceIds.forEach(id => {
                    this.serviceTypes.forEach(type => {
                        if (id == type.id) {
                            list.push(type);
                        }
                    });
                });
            }

            return list;
        },
        toggleFilters() {
            this.showFilters = !this.showFilters;
        }
    },
    filters: {
        titlecase(value){
            return value.toLowerCase().replace(/(?:^|\s|-)\S/g, x => x.toUpperCase());
        }
    }
};
</script>
